export default {

  // See activityLinkedObjectTypes
  iconClassByType(type) {
    switch (type) {
      case "mortgage":
        return "mdi mdi-home";
      case "customer":
        return "mdi mdi-account-multiple";
      case "policy":
        return "mdi mdi-umbrella";
      case "damage":
        return "mdi mdi-bullhorn";
      case "credit":
        return "mdi mdi-wallet";
      case "task":
        return "mdi mdi-check";
      case "email":
        return "mdi mdi-email";
      case "visit":
        return "mdi mdi-calendar";
      case "letter":
        return "mdi mdi-paperclip";
      case "attachable":
        return "mdi mdi-file";
      default:
        return "mdi mdi-checkbox-blank-circle-outline";
    }
  },
};
